import _get from 'lodash/get'
import _merge from 'lodash/merge'
import _remove from 'lodash/remove'

import {setOne} from '../_storeMethods'
import {$axios, StoreCollection} from '../StoreCollection'

let s = {}

const dataNamespace = 'appInitialData.stores.PersonalInformationForms'

_merge(s, StoreCollection, {
  state: {
    // configure base endpoint
    apiBaseUrl: '/api/v1/pifs',

    // set Bags, there may be defaults set under window.appInitialData
    collection: _get(window, `${dataNamespace}.collection`, []),
    template: _get(window, `${dataNamespace}.template`, null),
    form: _get(window, `${dataNamespace}.form`, {})
  },
  mutations: {
    setOne
  },
  actions: {
    resetCollection(context) {
      context.commit('set', {
        field: 'collection',
        value: []
      })
      context.dispatch('bootFor', [
        'where',
        'trip_dashboard_id',
        context.rootGetters.currentTripDashboardId
      ])
    },
    toggleUserAccess(context, payload) {
      if (payload.pifId && payload.userId) {
        return new Promise(resolve => {
          $axios
            .post(`${context.state.apiBaseUrl}/${payload.pifId}/toggleUserAccess/${payload.userId}`)
            .then(res => {
              if (res.status === 200) {
                context.commit('setOne', { resource: res.data })
                resolve()
              }
            })
        })
      }
    },
    updateDoesNotOwnEmail(context, payload) {
      if (payload.pifId) {
        return new Promise(resolve => {
          $axios
            .post(`${context.state.apiBaseUrl}/${payload.pifId}/updateDoesNotOwnEmail`, {
              does_not_own_email: payload.doesNotOwnEmail
            })
            .then(res => {
              if (res.status === 200) {
                context.commit('setOne', { resource: res.data })
                resolve()
              }
            })
        })
      }
    },
    updateOrder(context, payload) {
      if (payload.pifId && payload.action) {
        return new Promise(resolve => {
          $axios
            .post(`${context.state.apiBaseUrl}/${payload.pifId}/updateOrder/${payload.action}`)
            .then(res => {
              if (res.status === 200) {
                context.commit('set', {
                  field: 'collection',
                  value: res.data
                })
                resolve()
              }
            })
        })
      }
    },
    createFromContact(context, payload) {
      return new Promise(resolve => {
        $axios
          .post(
            `${context.state.apiBaseUrl}/create-from-contact/${context.rootGetters.currentTripDashboardId}/${payload.contactId}`
          )
          .then(res => {
            if ([200,201].includes(res.status)) {
              context.commit('set', {
                field: 'collection',
                value: res.data
              })
              resolve()
            }
            else {
              console.error(res)
              throw new Error("Failed to create PIF from Contact.")
            }
          })
      })
    },

    //      INFUSIONSOFT DUPLICATES

    getInfusionsoftDuplicates(context, payload) {
      if (payload.id) {
        return new Promise((resolve, reject) => {
          $axios
            .get(`${context.state.apiBaseUrl}/${payload.id}/infusionsoft-duplicates`, payload.model)
            .then(res => {
              if (res.status === 200) {
                resolve(res.data)
              } else {
                reject()
              }
            })
        })
      }
    },

    updatePIFInCollection(context, payload) {
      const collection = context.state.collection
      _remove(collection, item => {
        return item.id === payload.pif.id
      })
      collection.push(payload.pif)
      context.commit('set', {
        field: 'collection',
        value: collection
      })
    }
  },
  getters: {
    pifs: state => {
      return state.collection
    },
    attachments: (state, getters, rootState, rootGetters) => {
      if (rootGetters['AttachmentsV2/forQuery']) {
        return rootGetters['AttachmentsV2/forQuery']({
          owner_type: 'App\\Models\\PersonalInformationForm'
        })
      }
    }
  }
})
export default s
